import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/config/queryKeys';
import { settingsRepository } from './settingsRepository';

export function useSiteSettings() {
  return useQuery({
    queryKey: queryKeys.siteSettings,
    queryFn: () => settingsRepository.get(),
    staleTime: 5 * 60_000,
  });
}
